import React from "react";
import "./style.css";
export default function Modal(props) {
  if (!props.show) {
    return null;
  }
  return (
    <div className="modal modal--md">
      <div className="app-body__content" style={props.contentStyle}>{props.children}</div>
    </div>
  );
}
